import React, { useState } from 'react'
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { FaBinoculars, FaBus, FaCar, FaFilter, FaHelicopter, FaHotel, FaMotorcycle, FaPlane, FaShip, FaUtensils } from 'react-icons/fa';
import { GroupTourDestinations, GroupTourPackages } from '../data/Destination';
import Breadcrumb from '../components/Breadcrumb';
import deafultImage from "../assets/tour-package.jpg"
import { FaPassport, FaStar } from 'react-icons/fa6';
import { useEffect, useRef } from 'react'
import HelmetComponent from '../components/Helmet';

const GroupPackages = () => {
    const [showFilter, setShowFilter] = useState(false);

    const [filters, setFilters] = useState({
        flight: [],
        departure: [],
        stars: [],
        cities: [],
        duration: [],

    });
    const allDates = [
        ...new Set(
            GroupTourPackages.flatMap(pkg =>
                pkg.availableDate?.map(d => d.trim()) || []
            )
        )
    ];
    const allCities = [
        ...new Set(
            GroupTourPackages.flatMap(pkg =>
                pkg.departureCity || []
            )
        )
    ];
    const navigate = useNavigate();
    const { slug } = useParams();
    const location = useLocation();
    const path = location.pathname;
    const groupPackages = useRef(null)
    const getVariant = (path) => {
        if (path.includes(`/group-tour`)) return "groupTour";
        if (path === "/") return "home";
        return "default";
    };
    useEffect(() => {
        if (groupPackages.current) {
            groupPackages.current.scrollIntoView({ behavior: "auto" });
        }
    }, []);
    const handleFilterChange = (type, value) => {
        setFilters((prev) => {
            const exists = prev[type].includes(value);

            return {
                ...prev,
                [type]: exists
                    ? prev[type].filter((v) => v !== value)
                    : [...prev[type], value]
            };
        });
    };
    const clearAllFilter = () => {
        setFilters({
            flight: [],
            departure: [],
            stars: [],
            cities: [],
            duration: [],
        });
        setShowFilter(false);
    };
    const getNights = (duration) => {
        const match = duration?.match(/\d+/);
        return match ? parseInt(match[0]) : 0;
    };
    const durationOptions = [
        { label: "1-3 Nights", min: 1, max: 3 },
        { label: "4-6 Nights", min: 4, max: 6 },
        { label: "7-10 Nights", min: 7, max: 10 },
        { label: "11-15 Nights", min: 11, max: 15 },
        { label: "16+ Nights", min: 16, max: 100 },
    ];
    const filteredPackages = GroupTourPackages.filter((pkg) => {

        // Flight
        if (filters.flight.length) {
            const hasFlight = pkg.includes?.includes("flights");

            const match = filters.flight.some((f) => {
                if (f === "With Flight") return hasFlight;
                if (f === "Without Flight") return !hasFlight;
                return false;
            });

            if (!match) return false;
        }

        // Departure Month
        if (filters.departure.length) {
            const match = pkg.availableDate?.some(date =>
                filters.departure.includes(date)
            );
            if (!match) return false;
        }

        // Cities
        if (filters.cities.length) {
            const match = pkg.departureCity?.some(city =>
                filters.cities.includes(city)
            );
            if (!match) return false;
        }

        // Duration
        if (filters.duration.length) {
            const nights = getNights(pkg.duration);

            const match = durationOptions.some((opt) => {
                if (!filters.duration.includes(opt.label)) return false;
                return nights >= opt.min && nights <= opt.max;
            });

            if (!match) return false;
        }

        // Stars
        if (filters.stars.length) {
            if (!filters.stars.includes(`${pkg.stars} Star`)) return false;
        }

        return true;
    });
    const formatSlug = (str) => {
        return str
            ?.replace(/-/g, " ")
            ?.split(" ")
            ?.map(word =>
                word.charAt(0).toUpperCase() + word.slice(1)
            )
            ?.join(" ");
    };
    const formattedSlug = formatSlug(slug);
    const seoTitle =
        slug === "all"
            ? "Group Tour Packages | Domestic & International Group Tours"
            : `${formattedSlug} Group Tour Packages | Shri Radhe Holidays`;

    const seoDescription =
        slug === "all"
            ? "Explore affordable domestic and international group tour packages with Shri Radhe Holidays. Book group trips, family tours, honeymoon tours, sightseeing and customized holiday packages."
            : `Explore ${formattedSlug} group tour packages with Shri Radhe Holidays. Book affordable group trips, family vacations, sightseeing tours, hotels, meals and customized travel packages.`;

    const seoImage =
        filteredPackages?.[0]?.image ||
        "https://www.shriradheholidays.com/logo2.png";

    const seoUrl =
        `https://www.shriradheholidays.com/group-tour/${slug}`;
    return (
        <>
            <HelmetComponent
                title={seoTitle}
                description={seoDescription}
                image={seoImage}
                url={seoUrl}
            />
            <div className='max-md:px-4 md:px-4 lg:px-4 xl:px-6 py-4 scroll-mt-[90px]' ref={groupPackages}>
                <Breadcrumb destination={slug} variant={getVariant(path)} />
                <div className={`flex items-center justify-between mt-6  max-lg:mx-2  mx-0 text-start border-x-8  bg-[#0B1C3D]  border-[#D4AF37] wow fadeInUp max-sm:w-[98%] w-full transform -skew-x-12`} data-wow-delay="0.1s"
                    style={{ boxShadow: ' 0px 0px 20px 5px  rgb(0 0 0 / 32%)' }}
                >
                    {/* Heading */}
                    <h1 className=" playfair-display font-extrabold py-[6px] px-2 max-lg:text-xl text-2xl text-white capitalize">
                        {slug} Group Tour Packages
                    </h1>
                    <button
                        onClick={() => setShowFilter(true)}
                        className="flex items-center gap-2 bg-[#0B1C3D] text-white px-4 py-2 rounded-md"
                    >
                        <FaFilter />
                        Filter
                    </button>
                </div>
                <div className='flex max-sm:flex-col md:flex-col lg:flex-row xl:flex-row 2xl:flex-row w-full'>
                    <div className='h-full mt-4 grid max-md:grid-cols-1 md:grid-cols-1 lg:grid-cols-1 xl:grid-cols-2 gap-2  max-md:flex-col  lg:flex-row xl:flex-row 2xl:flex-row max-lg:w-full w-full '>
                        {filteredPackages
                            ?.filter(pkg =>
                                slug === "all"
                                    ? true
                                    : pkg.categories?.includes(slug)
                            )
                            ?.map((pkg, index) => (
                                <div
                                    key={pkg.id || index}
                                    className="cursor-pointer max-md:h-[450px]  md:h-[300px] lg:h-[300px] xl:h-[350px]  w-full bg-[#ffffff] rounded-xl border-1 border-[#D4AF37] shadow-md overflow-hidden flex flex-col md:flex-row  mb-2 mr-2 "
                                    onClick={() => navigate(pkg?.path || "/")}
                                >
                                    {/* IMAGE */}
                                    <div className="relative w-full h-full overflow-hidden hover:scale-105 transition duration-500">
                                        <img
                                            src={pkg?.image || deafultImage}
                                            alt={pkg?.title || "Destination Packages"}
                                            loading="lazy"
                                            className="w-full h-full object-cover"
                                        />

                                        {/* CODE TAG */}
                                        <span className="poppins font-semibold absolute top-3  left-0 bg-white text-[#0B1C3D] text-sm px-2 py-1  border-l-4 border-[#D4AF37]  rounded-r-lg">
                                            Group Tour
                                        </span>

                                    </div>

                                    {/* CONTENT */}
                                    <div className="my-3 w-full flex flex-col justify-evenly">
                                        {/* TOP */}
                                        <div>
                                            <div className="flex flex-col justify-start items-start px-3">
                                                <h3 className="hanuman-bold text-[#0B1C3D]  max-md:text-[16px]  md:text-[14px] lg:text-[16px] xl:text-lg md:text-xl mb-0 ">
                                                    {pkg?.title || "Package"}
                                                </h3>
                                                <div className="flex items-center text-[12px] gap-1 text-[#D4AF37] mb-1">
                                                    {[...Array(pkg?.stars || 0)].map((_, i) => (
                                                        <FaStar key={i} />
                                                    ))}
                                                </div>
                                                {pkg?.duration && (
                                                    <div className="text-sm text-[#0B1C3D] font-semibold poppins">
                                                        {pkg.duration}
                                                    </div>
                                                )}
                                            </div>

                                            {pkg?.route && (<p className="max-md:text-[12px] pr-[40px] text-sm text-[#0B1C3D] mt-0 px-3 poppins">
                                                {pkg?.route}
                                            </p>
                                            )}

                                            {/* INCLUSIONS */}
                                            {pkg?.includes && (<div className="mt-3 border px-2 py-2 w-full flex justify-around items-center max-md:text-[15px] md:text-[15px] lg:text-[13px] xl:text-[14px] bg-[#0B1C3D]/20  text-[#0B1C3D]">

                                                {pkg?.includes?.includes("flights") && (
                                                    <div className="flex flex-col items-center poppins">
                                                        <FaPlane />
                                                        <span>Flights</span>
                                                    </div>
                                                )}

                                                {pkg?.includes?.includes("hotels") && (
                                                    <div className="flex flex-col items-center poppins">
                                                        <FaHotel />
                                                        <span>Hotels</span>
                                                    </div>
                                                )}
                                                {pkg?.includes?.includes("hotel") && (
                                                    <div className="flex flex-col items-center poppins">
                                                        <FaHotel />
                                                        <span>Hotel</span>
                                                    </div>
                                                )}

                                                {pkg?.includes?.includes("sightseeing") && (
                                                    <div className="flex flex-col items-center poppins">
                                                        <FaBinoculars />
                                                        <span>Sightseeing</span>
                                                    </div>
                                                )}

                                                {pkg?.includes?.includes("transfers") && (
                                                    <div className="flex flex-col items-center poppins">
                                                        <FaCar />
                                                        <span>Transfers</span>
                                                    </div>
                                                )}

                                                {pkg?.includes?.includes("meals") && (
                                                    <div className="flex flex-col items-center poppins">
                                                        <FaUtensils />
                                                        <span>Meals</span>
                                                    </div>
                                                )}
                                                {pkg?.includes?.includes("desert-safari") && (
                                                    <div className="flex flex-col items-center poppins">
                                                        <FaCar />
                                                        <span>Desert Safari</span>
                                                    </div>
                                                )}
                                                {pkg?.includes?.includes("cruise") && (
                                                    <div className="flex flex-col items-center poppins">
                                                        <FaShip />
                                                        <span>Cruise</span>
                                                    </div>
                                                )}
                                                {pkg?.includes?.includes("5-star-hotels") && (
                                                    <div className="flex flex-col items-center poppins">
                                                        <FaHotel />
                                                        <span>5 Star Hotel</span>
                                                    </div>
                                                )}
                                                {pkg?.includes?.includes("resort") && (
                                                    <div className="flex flex-col items-center poppins">
                                                        <FaHotel />
                                                        <span>Resort</span>
                                                    </div>
                                                )}
                                                {pkg?.includes?.includes("volvo") && (
                                                    <div className="flex flex-col items-center poppins">
                                                        <FaBus />
                                                        <span>Volvo</span>
                                                    </div>
                                                )}
                                                {pkg?.includes?.includes("bike") && (
                                                    <div className="flex flex-col items-center poppins">
                                                        <FaMotorcycle />
                                                        <span>Bike</span>
                                                    </div>
                                                )}
                                                {pkg?.includes?.includes("visa") && (
                                                    <div className="flex flex-col items-center poppins">
                                                        <FaPassport />
                                                        <span>Visa</span>
                                                    </div>
                                                )}
                                                {pkg?.includes?.includes("helicopter") && (
                                                    <div className="flex flex-col items-center poppins">
                                                        <FaHelicopter />
                                                        <span>Helicopter</span>
                                                    </div>
                                                )}

                                            </div>
                                            )}
                                        </div>

                                        {/* BOTTOM */}
                                        <div className="flex justify-between items-center mt-2 px-3 poppins">

                                            {/* PRICE */}
                                            <div>
                                                <div className="text-sm  mb-1 text-[#0B1C3D]">Starting From</div>
                                                <div className="text-xl mb-1 font-bold text-[#0B1C3D]">
                                                    ₹{pkg?.price?.toLocaleString() || "N/A"}/-
                                                </div>
                                                <div className="text-xs text-[#0B1C3D]">
                                                    Per Person on Twin Sharing
                                                </div>
                                            </div>

                                            {/* BUTTON */}
                                            <div className="flex justify-center md:justify-start mr-2">
                                                <a
                                                    href={`https://wa.me/919560070953?text=${encodeURIComponent(
                                                        `Hi, I’m interested in  ${" the " + pkg?.title || "this"} holiday package.
                                                            Please share the best price, itinerary, and available options.`
                                                    )}`} target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="no-underline "
                                                >
                                                    <button
                                                        type="submit"
                                                        className="relative z-10 overflow-hidden group flex items-center justify-center gap-2 
                                                            rounded-full shadow-xl isolation-auto transition-all duration-700
                                                            bg-[#0B1C3D] text-[#D4AF37] hover:text-gray-50
                                                            px-3 py-2 text-sm sm:px-6 sm:py-3 sm:text-base lg:px-8 lg:py-3 lg:text-sm lg:font-semibold
                                                            before:absolute before:w-full before:transition-all before:duration-700 
                                                            before:-left-full before:hover:left-0 before:rounded-full before:bg-[#D4AF37] 
                                                            before:-z-10 before:aspect-square before:hover:scale-150"
                                                    >
                                                        <span className="whitespace-nowrap">Send Inquire</span>
                                                        <svg
                                                            className="shrink-0 ease-linear duration-300 rounded-full border border-[#D4AF37] p-2 rotate-45
                                                                    w-6 h-6 sm:w-7 sm:h-7 
                                                                    group-hover:rotate-90 group-hover:bg-gray-50 group-hover:border-none"
                                                            viewBox="0 0 16 19"
                                                        >
                                                            <path
                                                                d="M7 18C7 18.5523 7.44772 19 8 19C8.55228 19 9 18.5523 9 18H7ZM8.70711 0.292893C8.31658 -0.0976311 7.68342 -0.0976311 7.29289 0.292893L0.928932 6.65685C0.538408 7.04738 0.538408 7.68054 0.928932 8.07107C1.31946 8.46159 1.95262 8.46159 2.34315 8.07107L8 2.41421L13.6569 8.07107C14.0474 8.46159 14.6805 8.46159 15.0711 8.07107C15.4616 7.68054 15.4616 7.04738 15.0711 6.65685L8.70711 0.292893ZM9 18L9 1H7L7 18H9Z"
                                                                className="fill-[#D4AF37]"
                                                            ></path>
                                                        </svg>
                                                    </button>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                    <div className="lg:ml-2 xl:ml-2 mb-2 h-full  gap-2 mt-4 bg-white shadow-md  max-lg:w-full lg:w-[30%] xl:w-[20%]">
                        {/* International Destinations Section */}

                        {GroupTourDestinations && (
                            <div>
                                <h3 className="playfair-display w-full font-extrabold py-[6px] px-2 text-[18px]  lg:text-[16px] xl:text-xl text-white text-start border-l-8 bg-[#0B1C3D] border-[#D4AF37]">
                                    More GroupTour Destinations
                                </h3>
                                <ul className="flex flex-col space-y-2 pl-2">
                                    {Array.isArray(GroupTourDestinations) &&
                                        GroupTourDestinations
                                            .map((dest, index) => (
                                                <li key={index} className=''>
                                                    <Link
                                                        to={dest?.link || "/"}
                                                        className="poppins text-[#0B1C3D]  max-md:text-[16px] md:text-[16px] lg:text-[14px] xl:text-[16px] no-underline px-2 hover:text-[#D4AF37] hover:translate-x-1 inline-block transition-all duration-200"
                                                    >
                                                        {dest?.name || "Destination"} GroupTour Packages
                                                    </Link>
                                                </li>
                                            ))}
                                </ul>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            {showFilter && (
                <div className="fixed inset-0  z-50  flex justify-start items-start">
                    <div className="bg-white max-md:w-full xl:w-[30%] h-full  ">
                        <div className={`flex items-center justify-between rounded-b-[35%]  px-2 text-start border-l-8  bg-[#0B1C3D]   border-[#D4AF37] wow fadeInUp  `} data-wow-delay="0.1s"
                        >
                            {/* Heading */}
                            <h1 className=" playfair-display mt-2 font-extrabold py-[6px] px-2 max-sm:text-xl xl:text-2xl text-[#ffffff]">
                                Package Filters
                            </h1>
                            <button className='text-[20px] text-[#ffffff] mr-5' onClick={() => setShowFilter(false)}>✕</button>
                        </div>

                        {/* Flights */}
                        <div className="my-2 px-2">
                            <h3 className="font-medium playfair-display  text-[20px] px-4 mb-3">Flights</h3>
                            <div className="grid  grid-cols-3 gap-y-2 px-4">
                                {["With Flight", "Without Flight"].map((item) => (
                                    <div class="flex items-center  space-x-2  text-[15px] ">
                                        <label class="containers">
                                            <input type="checkbox" checked={filters.flight.includes(item)} onChange={() => handleFilterChange("flight", item)} />
                                            <svg viewBox="0 0 64 64" height="1em" width="1em" >
                                                <path d="M 0 16 V 56 A 8 8 90 0 0 8 64 H 56 A 8 8 90 0 0 64 56 V 8 A 8 8 90 0 0 56 0 H 8 A 8 8 90 0 0 0 8 V 16 L 32 48 L 64 16 V 8 A 8 8 90 0 0 56 0 H 8 A 8 8 90 0 0 0 8 V 56 A 8 8 90 0 0 8 64 H 56 A 8 8 90 0 0 64 56 V 16" pathLength="575.0541381835938" class="path"></path>
                                            </svg>
                                        </label>
                                        <span className='poppins text-[#0B1C3D]/70 '>
                                            {item}
                                        </span>
                                    </div>

                                ))}
                            </div>
                        </div>
                        {/* Departure */}
                        <div className="my-2 px-2">
                            <h3 className="font-medium playfair-display text-[20px]  px-4 mb-3">Departure</h3>
                            <div className="grid grid-cols-3 gap-y-2 px-4">
                                {allDates.map((item) => (
                                    <div class="flex items-center  space-x-3 text-[15px] ">
                                        <label class="containers">
                                            <input type="checkbox" checked={filters.departure.includes(item)} onChange={() => handleFilterChange("departure", item)} />
                                            <svg viewBox="0 0 64 64" height="1em" width="1em">
                                                <path d="M 0 16 V 56 A 8 8 90 0 0 8 64 H 56 A 8 8 90 0 0 64 56 V 8 A 8 8 90 0 0 56 0 H 8 A 8 8 90 0 0 0 8 V 16 L 32 48 L 64 16 V 8 A 8 8 90 0 0 56 0 H 8 A 8 8 90 0 0 0 8 V 56 A 8 8 90 0 0 8 64 H 56 A 8 8 90 0 0 64 56 V 16" pathLength="575.0541381835938" class="path"></path>
                                            </svg>
                                        </label>
                                        <span className='poppins text-[#0B1C3D]/70 '>
                                            {item}
                                        </span>
                                    </div>

                                ))}
                            </div>
                        </div>

                        {/* Stars */}
                        <div className="mb-2 px-2">
                            <h3 className="font-medium playfair-display text-[20px]  px-4 mb-3">Hotel Rating</h3>
                            <div className="grid grid-cols-3 gap-y-2 px-4">
                                {["3 Star", "4 Star", "5 Star"].map((item) => (
                                    <div class="flex items-center  space-x-3 text-[15px]">
                                        <label class="containers">
                                            <input type="checkbox" checked={filters.stars.includes(item)} onChange={() => handleFilterChange("stars", item)} />
                                            <svg viewBox="0 0 64 64" height="1em" width="1em">
                                                <path d="M 0 16 V 56 A 8 8 90 0 0 8 64 H 56 A 8 8 90 0 0 64 56 V 8 A 8 8 90 0 0 56 0 H 8 A 8 8 90 0 0 0 8 V 16 L 32 48 L 64 16 V 8 A 8 8 90 0 0 56 0 H 8 A 8 8 90 0 0 0 8 V 56 A 8 8 90 0 0 8 64 H 56 A 8 8 90 0 0 64 56 V 16" pathLength="575.0541381835938" class="path"></path>
                                            </svg>
                                        </label>
                                        <span className='poppins text-[#0B1C3D]/70 '>
                                            {item}
                                        </span>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Cities */}
                        <div className="mb-2 px-2">
                            <h3 className="font-medium playfair-display text-[20px]  px-4 mb-3">Ex-City</h3>
                            <div className="grid grid-cols-3 gap-y-2 px-4">
                                {allCities.map((item) => (
                                    <div class="flex items-center  space-x-3 text-[15px] ">
                                        <label class="containers">
                                            <input type="checkbox" checked={filters.cities.includes(item)} onChange={() => handleFilterChange("cities", item)} />
                                            <svg viewBox="0 0 64 64" height="1em" width="1em">
                                                <path d="M 0 16 V 56 A 8 8 90 0 0 8 64 H 56 A 8 8 90 0 0 64 56 V 8 A 8 8 90 0 0 56 0 H 8 A 8 8 90 0 0 0 8 V 16 L 32 48 L 64 16 V 8 A 8 8 90 0 0 56 0 H 8 A 8 8 90 0 0 0 8 V 56 A 8 8 90 0 0 8 64 H 56 A 8 8 90 0 0 64 56 V 16" pathLength="575.0541381835938" class="path"></path>
                                            </svg>
                                        </label>
                                        <span className='poppins text-[#0B1C3D]/70 '>
                                            {item}
                                        </span>
                                    </div>
                                ))}
                            </div>
                        </div>
                        {/* Duration */}
                        <div className="mb-4 px-2">
                            <h3 className="font-medium playfair-display text-[20px] px-4 mb-3">Duration</h3>
                            <div className="grid grid-cols-3 gap-y-2 px-4">
                                {durationOptions.map((item) => (
                                    <div class="flex items-center  space-x-3 text-[15px]">
                                        <label class="containers">
                                            <input type="checkbox" checked={filters.duration.includes(item.label)} onChange={() => handleFilterChange("duration", item.label)} />
                                            <svg viewBox="0 0 64 64" height="1em" width="1em">
                                                <path d="M 0 16 V 56 A 8 8 90 0 0 8 64 H 56 A 8 8 90 0 0 64 56 V 8 A 8 8 90 0 0 56 0 H 8 A 8 8 90 0 0 0 8 V 16 L 32 48 L 64 16 V 8 A 8 8 90 0 0 56 0 H 8 A 8 8 90 0 0 0 8 V 56 A 8 8 90 0 0 8 64 H 56 A 8 8 90 0 0 64 56 V 16" pathLength="575.0541381835938" class="path"></path>
                                            </svg>
                                        </label>
                                        <span className='poppins text-[#0B1C3D]/70 '>
                                            {item.label}
                                        </span>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className='flex justify-center items-center w-full px-7'>
                            <button
                                onClick={() => setShowFilter(false)}
                                type="submit"
                                className="
                                    relative z-10 overflow-hidden group flex items-center justify-center gap-2 
                                    rounded-l-xl  shadow-xl isolation-auto transition-all duration-700
                                    w-full
                                    /* Colors */
                                    bg-[#0B1C3D] text-[#D4AF37] hover:text-gray-50
                                    
                                    /* Responsive Sizing (Mobile first) */
                                    px-3 py-2 text-sm           /* Default: Mobile */
                                    sm:px-6 sm:py-3 sm:text-sm /* Tablets */
                                    lg:px-8 lg:py-3 lg:text-sm   /* Desktop */
                                    lg:font-semibold
                                    
                                    /* Hover Effect Logic */
                                    before:absolute before:w-full before:transition-all before:duration-700 
                                    before:-left-full before:hover:left-0 before:rounded-full before:bg-[#D4AF37] 
                                    before:-z-10 before:aspect-square before:hover:scale-150
                                    "
                            >
                                <span className="whitespace-nowrap">Apply</span>
                            </button>
                            <button
                                onClick={() => clearAllFilter()}
                                type="submit"
                                className="
                                        relative z-10 overflow-hidden group flex items-center justify-center gap-2 
                                        rounded-r-xl  shadow-xl isolation-auto transition-all duration-700
                                         w-full
                                        /* Colors */
                                        bg-[#ffffff] text-[#0B1C3D] hover:text-[#0B1C3D]
                                        
                                        /* Responsive Sizing (Mobile first) */
                                        px-3 py-2 text-sm           /* Default: Mobile */
                                        sm:px-6 sm:py-3 sm:text-sm /* Tablets */
                                        lg:px-8 lg:py-3 lg:text-sm   /* Desktop */
                                        lg:font-semibold
                                        
                                        /* Hover Effect Logic */
                                        before:absolute before:w-full before:transition-all before:duration-700 
                                        before:-left-full before:hover:left-0 before:rounded-full before:bg-[#da0909] 
                                        before:-z-10 before:aspect-square before:hover:scale-150
                                        "
                            >
                                <span className="whitespace-nowrap ">Clear all</span>
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}

export default GroupPackages
